<template>
    <v-app>
        <v-container fluid>
            <v-row v-if="$insertAccess($route.path)">
                <v-col md="3" cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Others Info</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit" ref="addEmployee" id="addEmployee">
                                    <v-row class="pa-2">
                                        <v-col cols="12">

                                            <v-autocomplete
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="rfq_id.value.value"
                                                :items="getQuotationableRfqList"
                                                :item-title="(item) => `${item.code}`"
                                                item-value="id"
                                                @update:modelValue="onRfqChange"
                                                :error-messages="rfq_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    RFQ
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="Date of entry"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="csquotation_date.value.value"
                                                :error-messages="csquotation_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    CS Quotation Date
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-date-input>

                                            <v-text-field
                                                label="Transport Cost"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="transport_cost.value.value"
                                                :error-messages="transport_cost.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Transport Cost
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field>

                                            <v-text-field
                                                label="Service Charge"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="service_charge.value.value"
                                                :error-messages="service_charge.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Service Charge
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field>

                                            <v-text-field
                                                label="Others Charge"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="other_charge.value.value"
                                                :error-messages="other_charge.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Others Charge
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field>

                                            <v-text-field
                                                label="Lead Days"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="lead_days.value.value"
                                                :error-messages="lead_days.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Lead Days
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field>

                                            <v-autocomplete
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="department_id.value.value"
                                                :items="getHrmDepartmentList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="department_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Requesting Department
                                                    <span class="text-red-accent-4"></span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                                label="Supplier"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="supplier_id.value.value"
                                                :items="getSupplierMapList"
                                                :item-title="(item) => `${item.supplier.supplier_name}`"
                                                item-value="supplier_id"
                                                :error-messages="supplier_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Supplier
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-text-field
                                                label="CS Quotation By"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="csquotation_by.value.value"
                                                :error-messages="csquotation_by.errorMessage.value"
                                                autocomplete="off"
                                                :disabled="true"
                                                clearable
                                            ></v-text-field>

                                            <v-text-field
                                                label="CS Quotation By Mobile"
                                                density="compact"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="csquotation_by_mobile.value.value"
                                                :error-messages="csquotation_by_mobile.errorMessage.value"
                                                autocomplete="off"
                                                :disabled="true"
                                                clearable
                                            ></v-text-field>

                                            <v-text-field
                                                label="CS Quotation By Email"
                                                density="compact"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="csquotation_by_email.value.value"
                                                :error-messages="csquotation_by_email.errorMessage.value"
                                                :disabled="true"
                                                autocomplete="off"
                                                clearable
                                            ></v-text-field>

                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>


                <v-col md="9" cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">Item Info</v-expansion-panel-title>
                            <v-expansion-panel-text>
                                <v-form ref="addEmployee" id="addEmployee">

                                    <v-row class="pt-2 justify-center d-none">
                                        <v-col cols="8">
                                            <v-autocomplete
                                                label="Search Product Name"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="product_id.value.value"
                                                :items="getProductMapList"
                                                :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'"
                                                item-value="product_id"
                                                :error-messages="product_id.errorMessage.value"
                                                @update:model-value="addCart"
                                                @keydown.enter="addCart"
                                                autocomplete="off"
                                                clearable
                                            ></v-autocomplete>
                                            <input v-model="csquotation_master_id.value.value" type="hidden" />
                                        </v-col>
                                    </v-row>

                                    <!-- Cart Table -->
                                    <v-row class="pt-0 mt-1">
                                        <v-col cols="12">
                                            <div class="scrollable-table-wrapper">
                                                <v-table density="compact" :loading="loading" fixed-header class="table-dotted-border-bottom" style="height:40vh; overflow-y: scroll;">
                                                    <thead>
                                                        <tr>
                                                            <th class="text-center" style="width: 50px;">SL</th>
                                                            <th class="text-left" style="width: 250px;">Product Code</th>
                                                            <th class="text-left" style="width: 250px;">Product Name</th>
                                                            <th class="text-center" style="width: 210px;">Offered Qnty</th>
                                                            <th class="text-center" style="width: 100px;">Unit</th>
                                                            <th class="text-center" style="width: 250px;">Unit Price</th>
                                                            <th class="text-center" style="width: 170px;">Sub Total</th>
                                                            <th class="text-center" style="width: 170px;">Delivery Time</th>
                                                            <th class="text-center" style="width: 140px;">Warranty</th>
                                                            <th class="text-center" style="width: 140px;">Validity</th>
                                                            <th class="text-center" style="width: 160px;">Payment Terms</th>
                                                            <th class="text-center" style="width: 250px;">Remarks</th>
                                                            <th class="text-center" style="width: 80px;">Action</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in cart" v-if="cart.length > 0" :key="index">
                                                            <td class="text-center pa-0" style="padding:2px !important;">{{ index + 1 }}</td>
                                                            <td class="text-left pa-0" style="padding:2px !important; white-space: normal;">{{ item.product_code }}</td>
                                                            <td class="text-left pa-0" style="padding:2px !important; white-space: normal;">{{ item.product_name }}</td>
                                                            <td class="text-right pa-0" style="padding:2px !important;">
                                                                <v-text-field
                                                                    :reverse="false"
                                                                    controlVariant="stacked"
                                                                    label=""
                                                                    type="number"
                                                                    style="width: 100px;"
                                                                    :hideInput="false"
                                                                    :inset="false"
                                                                    :min="1"
                                                                    density="compact"
                                                                    hide-details
                                                                    variant="outlined"
                                                                    bg-color="grey-lighten-4"
                                                                    v-model="item.qty"
                                                                    :error-messages="item.qty < 1 ? 'Quantity must be greater than 0' : ''"
                                                                    @update:model-value="item.total = item.qty * item.rate"
                                                                    @blur="item.total = item.qty * item.rate"
                                                                ></v-text-field>
                                                            </td>
                                                            <td class="text-center pa-0" style="padding:2px !important;">{{ item.unit_name }}</td>
                                                            <td class="text-center pa-0" style="padding:2px !important;">
                                                                <v-text-field
                                                                    :reverse="false"
                                                                    controlVariant="stacked"
                                                                    label=""
                                                                    type="number"
                                                                    style="width: 100px;"
                                                                    :hideInput="false"
                                                                    :inset="false"
                                                                    :min="1"
                                                                    hide-details
                                                                    density="compact"
                                                                    variant="outlined"
                                                                    bg-color="grey-lighten-4"
                                                                    v-model="item.rate"
                                                                    @update:model-value="item.total = item.qty * item.rate"
                                                                    @blur="item.total = item.qty * item.rate"
                                                                    :error-messages="item.rate < 1 ? 'Quantity must be greater than 0' : ''"
                                                                ></v-text-field>
                                                            </td>
                                                            <td class="text-center py-1">{{ this.$numberFormat(item.total) }}</td>
                                                            <td class="text-right pa-0" style="padding:2px !important;">
                                                                <v-text-field
                                                                    v-model="item.delivery_time"
                                                                    label=""
                                                                    density="compact"
                                                                    hide-details
                                                                    placeholder="Days"
                                                                    variant="outlined"
                                                                    bg-color="grey-lighten-4"
                                                                ></v-text-field>
                                                            </td>
                                                            <td class="text-right pa-0" style="padding:2px !important;">
                                                                <v-text-field
                                                                    v-model="item.warranty"
                                                                    label=""
                                                                    density="compact"
                                                                    placeholder="Month"
                                                                    variant="outlined"
                                                                    hide-details
                                                                    bg-color="grey-lighten-4"
                                                                ></v-text-field>
                                                            </td>
                                                            <td class="text-right pa-0" style="padding:2px !important;">
                                                                <v-text-field
                                                                    v-model="item.validity"
                                                                    label=""
                                                                    density="compact"
                                                                    placeholder="Year"
                                                                    variant="outlined"
                                                                    hide-details
                                                                    bg-color="grey-lighten-4"
                                                                ></v-text-field>
                                                            </td>
                                                            <td class="text-right pa-0" style="padding:2px !important;">
                                                                <v-text-field
                                                                    v-model="item.payment_terms"
                                                                    label=""
                                                                    density="compact"
                                                                    placeholder="Terms"
                                                                    variant="outlined"
                                                                    hide-details
                                                                    bg-color="grey-lighten-4"
                                                                ></v-text-field>
                                                            </td>
                                                            <td class="text-right pa-0" style="padding:2px !important;">
                                                                <v-text-field
                                                                    label=""
                                                                    density="compact"
                                                                    variant="outlined"
                                                                    placeholder="Remarks"
                                                                    bg-color="grey-lighten-4"
                                                                    hide-details
                                                                    v-model="item.remarks"
                                                                    autocomplete="off"
                                                                ></v-text-field>
                                                            </td>
                                                            <td class="text-center pa-0" style="padding:2px !important;">
                                                                <v-icon
                                                                    size="small"
                                                                    color="red"
                                                                    class="delete-button"
                                                                    @click="removeFromCart(index)">
                                                                    mdi-delete
                                                                </v-icon>
                                                            </td>
                                                        </tr>
                                                        <tr v-else-if="loading == true"><td colspan="12" class="text-center"><v-skeleton-loader type="heading" :loading="loading" /></td></tr>
                                                        <tr v-else><td colspan="12" class="text-center text-red">You have no item</td></tr>
                                                    </tbody>
                                                </v-table>
                                            </div>
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>

                    <v-expansion-panels v-model="panel3" class="my-8">
                        <v-expansion-panel>
                            <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                                Evaluation Info
                            </v-expansion-panel-title>

                            <v-expansion-panel-text>
                                <v-form ref="evaluationForm" id="evaluationForm">

                                    <!-- Evaluation Criteria Selector -->
                                    <v-row class="pt-2 justify-center">
                                        <v-col cols="8">
                                            <v-autocomplete
                                                label="Search Evaluation Criteria"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="selectedEvaluationCriteriaId"
                                                :items="getEvaluationCriteriaList"
                                                :item-title="(item) => `${item.name}-(${item.effective_from_date})-to-(${item.effective_to_date? item.effective_to_date: 'continued'})`"
                                                item-value="id"
                                                @update:model-value="addEvaluationToScores"
                                                autocomplete="off"
                                                clearable
                                            ></v-autocomplete>
                                        </v-col>
                                    </v-row>

                                    <v-row class="pt-0 mt-1">
                                        <v-col cols="12">
                                            <div class="scrollable-table-wrapper">
                                                <v-table density="compact" fixed-header class="table-dotted-border-bottom" style="height: 50vh; min-width: 500px !important; overflow-y: scroll;">
                                                    <thead>
                                                        <tr>
                                                            <th class="text-center">SL</th>
                                                            <th class="text-left" >Field Name</th>
                                                            <th class="text-center" >Weight (%)</th>
                                                            <th class="text-center" >Value</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr 
                                                            v-for="(scoreItem, index) in scores" 
                                                            v-if="scores.length > 0" 
                                                            :key="scoreItem.id"
                                                            >
                                                            <td class="text-center">
                                                                {{ index + 1 }}
                                                            </td>
                                                            <td class="text-left" style="white-space: normal; text-transform: capitalize;">
                                                                {{ scoreItem.field_name }}
                                                            </td>
                                                            <td class="text-center">
                                                                {{ scoreItem.weight_percent }}%
                                                            </td>

                                                            <td class="text-center">
                                                                <v-text-field
                                                                    v-model="scoreItem.score"
                                                                    density="compact"
                                                                    variant="outlined"
                                                                    hide-details
                                                                    :min="0"
                                                                />
                                                            </td>
                                                        </tr>
                                                        <tr v-else>
                                                            <td class="text-center text-red">
                                                                Please select an evaluation criteria to load the details
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </v-table>
                                            </div>
                                        </v-col>
                                    </v-row>

                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-row class="pt-2">
                                            <v-col cols="8">
                                                <v-textarea
                                                    label="Description"
                                                    density="compact"
                                                    variant="outlined"
                                                    bg-color="grey-lighten-4"
                                                    v-model="remarks.value.value"
                                                    :error-messages="remarks.errorMessage.value"
                                                    autocomplete="off"
                                                    rows="3"
                                                    clearable
                                                ></v-textarea>
                                            </v-col>
                                            <v-col cols="4">
                                                <v-layout class="justify-end">
                                                    <v-btn
                                                        class="bg-grey-darken-1 me-2"
                                                        variant="flat"
                                                        @click="submitForm(0)"
                                                    >DRAFT</v-btn>
                                                    <v-btn
                                                        class="bg-primary"
                                                        variant="flat"
                                                        @click="submitForm(1)"
                                                    >POST</v-btn>
                                                </v-layout>
                                            </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>

                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>

import { useStore } from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { toast } from 'vue3-toastify';
import formattedDate from '@/plugins/dateFormatter';
import { useRouter } from 'vue-router';

export default {
    components: {},

    data: () => ({
        panel: [0],
        panel2: [0],
        panel3: [0],
        loading: false,
        errorMessages: '',
        visible: false,
        search: "",
        selectedImage: null,
        photo_imageFile: '',
        preview: '/src/assets/no_preview.png',
        cart: [],
        selectedEvaluationCriteriaId: null,
        scores: [],
    }),

    created() {
        if (this.$store.getters.getHrmDepartmentList.length === 0) { this.$store.dispatch('getHrmDepartmentList'); }
        if (this.$store.getters.getWarehouseList.length === 0) { this.$store.dispatch('getWarehouseList'); }
        if (this.$store.getters.getProductMapList.length === 0) { this.$store.dispatch('getProductMapList'); }
        if (this.$store.getters.getSupplierMapList.length === 0) { this.$store.dispatch('getSupplierMapList'); }
        if (this.$store.getters.getPurRequisitionList.length === 0) { this.$store.dispatch('getPurRequisitionList'); }
        if (this.$store.getters.getEvaluationCriteriaList.length === 0) { this.$store.dispatch('getEvaluationCriteriaList'); }
        this.$store.dispatch('getQuotationableRfqList');
    },

    computed: {
        branchId() {
            return this.$store.getters.getAuthUser.branch_id || null;
        },
        getHrmDepartmentList() {
            return this.$store.getters.getHrmDepartmentList;
        },
        getWarehouseList() {
            return this.$store.getters.getWarehouseList;
        },
        getEvaluationCriteriaList() {
            return this.$store.getters.getEvaluationCriteriaList;
        },
        getProductMapList() {
            let products = this.$store.getters.getProductMapList;
            return products.filter(item => item.branch_id == this.branchId && item.status == 1);
        },
        getSupplierMapList() {
            let suppliers = this.$store.getters.getSupplierMapList;
            return suppliers.filter(item => item.branch_id == this.branchId && item.status == 1);
        },
        filteredPurRequisitionList() {
            const requisitions = this.$store.getters.getPurRequisitionList || [];
            return requisitions.filter(item => item.branch_id == this.branchId && item.status == 1);
        },
        getQuotationableRfqList() {
            const rfq = this.$store.getters.getQuotationableRfqList || [];
            return rfq.filter(item => item.branch_id == this.branchId);
        }
    },

    methods: {
        async fetchRequisitions() {
            this.$store.commit('SET_LOADING', { color: 'primary' });
            try {
                await this.$store.dispatch('getSelectedPurRequisitionList');
            } catch (error) {
                console.error('Failed to fetch requisitions:', error);
            }
        },

        addEvaluationToScores(selectedId) {
            if (!selectedId) {
                this.evaluationReset();
                return;
            }

            const selected = this.getEvaluationCriteriaList.find(item => item.id === selectedId);

            if (!selected || !selected.evaluation_criteria || selected.evaluation_criteria.length === 0) {
                toast.error("No evaluation criteria details found for the selected criteria.");
                this.evaluationReset();
                return;
            }

            const alreadyAdded = this.scores.some(
                s => s.pur_cs_evaluation_configuration_master_id === selected.id
            );
            if (alreadyAdded) {
                toast.error("This evaluation criteria has already been added.");
                this.evaluationReset();
                return;
            }

            selected?.evaluation_criteria?.forEach(criterion => {
                this.scores.push({
                    id: criterion.id,
                    pur_cs_evaluation_configuration_master_id: selected.id,
                    field_name: criterion.field_name,
                    weight_percent: criterion.weight_percent,
                    score: criterion.weight_percent,
                });
            });

            this.$nextTick(() => {
                this.evaluationReset();
            });
        },

        evaluationReset() {
            this.selectedEvaluationCriteriaId = null;
        },

        removeFromScores(index) {
            if (confirm("Are You Sure?")) {
                this.scores.splice(index, 1);
            }
        },

        addCart() {
            let cartInd = this.cart.findIndex(
                (p) => p.product_id == this.product_id.value.value
            );
            if (this.product_id.value.value == null) {
                toast.error("Please select a Product");
                this.cartReset();
                return false;
            }
            if (cartInd > -1) {
                toast.error("Product already added in cart");
                this.cartReset();
                return false;
            }

            let product = this.getProductMapList.find(
                (item) => item.product_id == this.product_id.value.value
            );
            product = product.product;

            let item = {
                product_id: this.product_id.value.value,
                product_name: product.name,
                product_code: product.code,
                qty: 1,
                unit_id: product.unit_id,
                unit_name: product.unit.name,
            };

            this.cart.push(item);
            this.$nextTick(() => {
                this.cartReset();
            });
        },

        removeFromCart(index) {
            if (confirm("Are You Sure?")) {
                this.cart.splice(index, 1);
            }
        },

        cartReset() {
            this.product_id.value.value = null;
        },

        async onRfqChange(selectedId) {
            if (!selectedId) {
                this.department_id.value.value = null;
                this.csquotation_date.value.value = null;
                this.cart = [];
                return;
            }
            try {
                this.$store.commit('SET_LOADING', { color: 'primary' });
                const data = await this.$store.dispatch('getRfqById', selectedId);

                this.department_id.value.value = data.department_id || data.department?.id || null;
                this.csquotation_date.value.value = data.csquotation_date ? new Date(data.csquotation_date) : null;
                this.remarks.value.value = data.remarks || '';

                this.cart = [];
                (data.rfq_details || []).forEach(item => {
                    this.cart.push({
                        product_id: item.product_id,
                        product_name: item.product?.name || '',
                        product_code: item.product?.code || '',
                        qty: item.qty,
                        unit_id: item.product?.unit_id || '',
                        unit_name: item.product?.unit?.name || '',
                        rate: item.rate,
                        total: item.qty * item.rate,
                    });
                });
                this.$store.commit('UNSET_LOADING');
            } catch (error) {
                console.error('Failed to load requisition data:', error);
            }
        },
    },

    setup() {
        const { handleSubmit, resetForm } = useForm({
            validationSchema: yup.object({
                csquotation_date: yup.date().required().label('CS Quotation Date'),
                rfq_id: yup.number().positive().integer().required().label('Rfq'),
                supplier_id: yup.number().positive().integer().required().label('Supplier'),
                transport_cost: yup.number().min(0).required().label('Transport Cost'),
                service_charge: yup.number().min(0).required().label('Service Charge'),
                other_charge: yup.number().min(0).required().label('Other Charge'),
                lead_days: yup.number().min(0).required().label('Lead Days'),
            }),
        });

        const product_id = useField('product_id');
        const pr_status = useField('pr_status');
        const employee_id = useField('employee_id');
        const department_id = useField('department_id');
        const rfq_id = useField('rfq_id');
        const supplier_id = useField('supplier_id');
        const csquotation_master_id = useField('csquotation_master_id');
        const csquotation_date = useField('csquotation_date');
        const transport_cost = useField('transport_cost');
        const service_charge = useField('service_charge');
        const other_charge = useField('other_charge');
        const lead_days = useField('lead_days');
        const remarks = useField('remarks');
        const csquotation_by = useField('csquotation_by');
        const csquotation_by_mobile = useField('csquotation_by_mobile');
        const csquotation_by_email = useField('csquotation_by_email');
        const errorMessages = ref('');
        const cart = ref([]);
        const scores = ref([]);
        const loading = ref('');
        const buttonText = ref('Save');
        const store = useStore();
        const router = useRouter();
        const currentStatus = ref(0);

        const submitForm = (status) => {
            currentStatus.value = status;
            submit();
        };

        const submit = handleSubmit((values) => {
            values.status = currentStatus.value;
            values.cart = cart.value;
            values.scores = scores.value;
            values.csquotation_date = formattedDate(csquotation_date.value.value);

            if (values?.scores.length === 0) {
                toast.error("Evaluation criteria cannot be empty!")
                return;
            }
            store.dispatch("saveUpdateCsQuotation", values)
                .then((response) => {
                    resetForm();
                    buttonText.value = 'Save';
                    cart.value = [];
                    scores.value = [];
                    toast.success(response.data.message, { timeout: 3000 });
                    setTimeout(() => {
                        router.push({ name: "cs-quotation-record" });
                    }, 2000);
                })
                .catch((error) => {
                    toast.error(error.response.data.message);
                });
        });

        return {
            submitForm,
            submit,
            product_id,
            csquotation_date,
            remarks,
            cart,
            scores,
            csquotation_by,
            csquotation_by_mobile,
            csquotation_by_email,
            transport_cost,
            service_charge,
            other_charge,
            lead_days,
            pr_status,
            errorMessages,
            employee_id,
            department_id,
            rfq_id,
            supplier_id,
            csquotation_master_id,
            buttonText,
            loading
        };
    },

    mounted() {
        this.pr_status.value.value = '1';
        this.employee_id.value.value = '';
        let user = this.$store.getters.getAuthUser;
        this.csquotation_by.value.value = user.full_name;
        this.csquotation_by_mobile.value.value = user.mobile;
        this.csquotation_by_email.value.value = user.email;

        const id = this.$route.query.id;
        if (id) {
            this.$store.commit('SET_LOADING', { color: 'primary' });
            this.$nextTick(() => {
                this.$store.dispatch('getCsQuotationById', id)
                    .then((data) => {
                        this.isEntryMode = false;
                        let quotation = data;
                        this.csquotation_master_id.value.value = quotation?.id;
                        this.csquotation_date.value.value = quotation?.csquotation_date ? new Date(quotation?.csquotation_date) : new Date();
                        this.transport_cost.value.value = quotation?.transport_cost;
                        this.service_charge.value.value = quotation?.service_charge;
                        this.other_charge.value.value = quotation?.other_charge;
                        this.lead_days.value.value = quotation?.lead_days;
                        this.rfq_id.value.value = quotation?.rfq_id || 1;

                        this.department_id.value.value = quotation?.department?.id ?? null;
                        this.product_id.value.value = null;
                        this.supplier_id.value.value = quotation?.supplier_id;
                        this.cart.value = [];

                        (quotation.quotation_details || []).forEach(item => {
                            this.cart.push({
                                product_id: item.product_id,
                                product_name: item.product?.name || '',
                                product_code: item.product?.code || '',
                                qty: item.qty,
                                unit_id: item.product.unit?.id || '',
                                unit_name: item.product.unit?.name || '',
                                rate: item.rate,
                                total: item.qty * item.rate,
                                remarks: item.remarks,
                                delivery_time: item.delivery_time,
                                warranty: item.warranty,
                                validity: item.validity,
                                payment_terms: item.payment_terms,
                            });
                        });

                        // Restore scores when editing
                        if (quotation.quotation_supplier_evaluations && quotation.quotation_supplier_evaluations.length > 0) {

                            this.scores = quotation.quotation_supplier_evaluations.map(ev => ({
                                id: ev.pur_cs_evaluation_criteria_detail_id,
                                pur_cs_evaluation_configuration_master_id: ev.pur_cs_evaluation_configuration_master_id ?? null,
                                field_name: ev.field_name,
                                weight_percent: ev.weight_percent,
                                score: ev.given_score,
                            }));
                        }

                        this.remarks.value.value = quotation.remarks ? quotation.remarks : '';
                        this.$store.commit('UNSET_LOADING');
                    })
                    .catch((error) => {
                        this.$store.commit('UNSET_LOADING');
                        console.error("Failed to fetch quotation:", error);
                    });
            });
        } else {
            this.csquotation_master_id.value.value = '';
            this.csquotation_date.value.value = new Date();
            this.isEntryMode = true;
        }
    },
};
</script>

<style scoped>
.scrollable-table-wrapper {
    overflow-x: auto;
    max-width: 100%;
}

.v-table {
    min-width: 1200px;
    table-layout: fixed;
}
</style>